module.exports = __webpack_public_path__ + "static/media/Inter-Thin.c51873c6.woff2";